<div id="bg-summary m-0">
  <usb-navbar-search-categories [getClientsSettingAppBooking]="getClientsSettingAppBooking" [_results]=""></usb-navbar-search-categories>

  <div style="background-color: #f8f6f7 !important; padding-bottom: 30px">
    <div class="top-summary container-limit-general mx-auto" >
      <div class="resumen pt-4">
        <usb-yourtrip-summary
          *ngIf="_actualItinerary"
          #yourTripSummary
          [qtyItemsToPartial]="qtyItemsToPartial"
          [appLoading]="appLoading"
          [actualItinerary]="_actualItinerary"
        >
        </usb-yourtrip-summary>
      </div>

      <div *ngIf="reloadItinerary" class="loading-container d-flex flex-column align-items-center justify-content-center py-5">
        <div class="logo-loading mb-4">
          <img [src]="agencyImagen" alt="Logo" class="loading-logo animate__animated animate__pulse animate__infinite" />
        </div>

        <div class="text-center animate__animated animate__fadeIn">
          <h4 class="text-muted mb-3">Estamos actualizando el file, gracias por esperar...</h4>

          <div
            [ngStyle]="{ color: getClientsSettingAppBooking?.clients_setting_global?.color_main_1 }"
            class="spinner-border"
            role="status"
          ></div>
        </div>
      </div>

      <div *ngIf="!reloadItinerary" class="resumen-itinerary pt-4 pb-4 mt-2">
        <usb-destiny-summary
          *ngIf="_actualItinerary && summaryItinerary && summaryItinerary.length > 0"
          class="w-100 d-flex"
          style="gap: 1.2em"
          [partialReserve]="partialReserve"
          [actualItinerary]="_actualItinerary"
          [qtyItemsToPartial]="qtyItemsToPartial"
          [suggestions]="suggestions"
          [currencies]="currencies"
          [currencyAgency]="currencyAgency"
          [permissions]="permissionsMap"
          [netPriceAgent]="netPriceAgent"
          [summaryItinerary]="summaryItinerary"
          [currencies]="currencies"
          (itemToPartial)="_itemToPartial($event)"
          (reloadSummaryItinerary)="reloadSummaryItineraryFx()"
          (goReserveFee)="goReserveFee()"
        >
        </usb-destiny-summary>
      </div>
    </div>
  </div>
</div>
